import { EventsDataGridWithQuery } from "../../components/EventsDataGrid/EventsDataGridWithQuery";

const EventLogBrowser = () => {
  return <EventsDataGridWithQuery />;
};

export { EventLogBrowser };
